import { Typography } from 'antd'
import { FC } from 'react'
import { TextLink } from './TextLink'

export const EmailLink: FC<typeof Typography.Link.defaultProps> = ({ title }) =>
  title ? <TextLink href={`mailto:${title}`}>{title}</TextLink> : null
